export default "# Section 区块\r\n\r\n页面内容分块。\r\n\r\n可承载文字、列表、图片、段落，常用于后台概览页面。\r\n\r\n## 何时使用\r\n\r\n- ...。";